
import * as api from "../../../api"; 


  
export const createALeadByManager = (post) => async (dispatch)=>{
    try {
        const {data } = await api.createALeadByManager(post);
       
        
        
        return data 
     } catch (error) {
        // dispatch({
        //     type: "LOGINLEAD",
            
        //     payload:null
        //   });  
    }
}

